import Instance from "./instance";

export const GetData = async (nameId) => {
  return Instance.instanceToken.get(`/campaign/p/${nameId}`)
};